import type { RootState } from '../reducers/rootReducer.ts';
import type ChartDOMPosition from '../models/guiState/chartDomPosition.ts';

export const sideBarStateSelector = (state: RootState) => state.guiStateReducer.sideMenuOpen;
export const chartPositionSelector = (state: RootState): ChartDOMPosition => state.guiStateReducer.chartDOMSize!;
